import {deserialize} from "serializr";
import firebase from "firebase";
import {MapModel} from "@/modules/mmaps/models/MapModel";
import {MapBackendUtils} from "@/modules/mmaps/database/MapBackendUtils";

export default {
    namespaced: true,
    state: {
        mMaps: [],
    },
    getters: {
        getMaps: state => {
            return state.mMaps;
        },
    },
    mutations: {
        setMaps(state, values) {
            state.mMaps = values;
        }
    },
    actions: {
        init({/*commit*/}) {
            console.info('maps-backend initialized.');
            return MapBackendUtils.fetchMaps()
        },
        fetchMaps({commit}){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'getMaps', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return data.text()
                                        .then((data)=>{
                                            //console.log(JSON.parse(data))
                                            //JSON.parse(data).map(v => console.log(v));
                                            let values = JSON.parse(data).map(v => deserialize(MapModel, v));
                                            commit("setMaps", values);
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        uploadMap({/*commit*/}, data){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                            body: JSON.stringify(data)
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'uploadMap', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return MapBackendUtils.fetchMaps()
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        removeMap({/*commit*/}, mapId){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "DELETE",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'removeMap/' + mapId, requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return MapBackendUtils.fetchMaps()
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        setMapAudience({/*commit*/}, value){
            console.log('setMapAudience:', JSON.stringify(value))
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                            body: JSON.stringify(value)
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'setMapAudience', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return MapBackendUtils.fetchMaps()
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        setMapCustomName({/*commit*/}, value){
            console.log('setMapCustomName:', JSON.stringify(value))
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                            body: JSON.stringify(value)
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'setMapCustomName', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return MapBackendUtils.fetchMaps()
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        setMapClientVersion({/*commit*/}, value){
            console.log('setMapClientVersion:', JSON.stringify(value))
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                            body: JSON.stringify(value)
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'setMapClientVersion', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return MapBackendUtils.fetchMaps()
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        duplicateMap({/*commit*/}, mapName){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'duplicateMap/' + mapName, requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return MapBackendUtils.fetchMaps()
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        getMap({/*commit*/}, mapName){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'getMap/' + mapName, requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return data.text()
                                        .then((data)=>{
                                            return data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
    }
}

